import * as React from 'react'
import Helmet from 'react-helmet'

import * as conprof from "./../assets/construction-profile.jpg"
import * as gconprof from "./../assets/genconstruction-profile.jpg"
import * as landprof from "./../assets/landarch-profile.jpg"
import * as poolprof from "./../assets/pool-profile.jpg"
import * as banner from "./../assets/services-banner.jpg"

import './services.css'

export default class extends React.Component<{}> {
  constructor(context: any) {
    super(context)
  }
  public render() {
    return (
      <div>
        <Helmet
            bodyAttributes={{
                class: 'services-body'
            }}
        />

        <div className="caption-container">
            <img width={980} height={273} alt="Fourth" src={banner} style={{margin: 0}}/>
            <h1 className="caption">THE WHOLE SCOPE OF LAND DEVELOPMENT SERVICES</h1>
        </div>

        <div style={{
            height: "auto",
            backgroundColor: "rgba(255, 255, 255, 0.75)",
            padding: "1px 25px 15px",
            marginBottom: "10px",
          }}>

          <p className="services-para">
            We offer comprehensive development services, providing land and real estate development concepts, landscape, architectural design and general construction to meet our clients' needs and desires.
          </p>

          <hr style={{margin: 0, marginTop: '2px', borderColor: 'rgb(150, 150, 150)'}}/>

          <h2 className="services-title">LANDSCAPE ARCHITECTURE <span style={{color: "#943616"}}>SERVICES</span></h2>

          <div className="profile-div">
            <div className="image-div">
              <img width={202} height={202} style={{boxShadow: "0px 5px 15px 0px #000000"}} alt="LandArchProfilePic" src={landprof}/>
            </div>
            
            <div>
                <p>
                    We know that the key to a successful landscape project is a well-prepared design: one that utilizes a variety of materials and ideas to form a full aesthetically pleasing composition.<br/><br/>
                    Under Juniper Inc. provides a complete array of landscape architectural services. We specialize in residential/commercial landscape design from intimate small-scale gardens to large-scale parks and recreational facilities.<br/><br/>
                    Services we provide include:<br/>
                    &nbsp;&nbsp;<span style={{fontSize: "8px"}}>&#x25CF;</span>&nbsp;&nbsp;&nbsp;Urban Design, Interior Landscape, Planning, and Landscape Architecture<br/>
                    &nbsp;&nbsp;<span style={{fontSize: "8px"}}>&#x25CF;</span>&nbsp;&nbsp;&nbsp;Feasibility Study, Schematic Design, Design Development<br/>
                    &nbsp;&nbsp;<span style={{fontSize: "8px"}}>&#x25CF;</span>&nbsp;&nbsp;&nbsp;Construction Documents<br/>
                    &nbsp;&nbsp;<span style={{fontSize: "8px"}}>&#x25CF;</span>&nbsp;&nbsp;&nbsp;Construction Administration<br/>
                </p>
                <a href="/gallery-la/">
                    <p className="gallery-link">
                        Go to Gallery  >
                    </p>
                </a>  
            </div>
          </div>

          <hr style={{margin: 0, marginTop: '20px', borderColor: 'rgb(150, 150, 150)'}}/>   

          <h2 className="services-title">DESIGN-BUILD <span style={{color: "#943616"}}>SERVICES</span></h2>

          <div className="profile-div">
            <div className="image-div">
                <img width={202} height={202} style={{boxShadow: "0px 5px 15px 0px #000000"}} alt="ConstructionProfilePic" src={conprof}/>
            </div>
            
            <div>
                <p>
                    Under Juniper Inc. specializes in high-quality, technically challenging and various-scale residential and commercial landscape design-build projects.<br/><br/>
                    We provide landscape construction in Northern California. From the careful installation of a single tree to the construction of patios, walkways, walls and water features, we can install a wide range of landscape items. Whether you want a desert themed landscape or one with the feeling of a tropical oasis, we will make sure that your new landscape is installed in a professional manner.<br/><br/>
                    As either the prime contractor or as part of a construction team, Under Juniper has the resources to provide high-quality landscape installation from concept to completion. Over the years, we have worked together with many specialty trades that allow us to perform a wide spectrum of services.<br/><br/>

                    <span style={{fontSize: "13px", color: "#8B0000", fontStyle: "italic"}}>Residential Landscape Installation</span><br/>
                    &nbsp;&nbsp;<span style={{fontSize: "8px"}}>&#x25CF;</span>&nbsp;&nbsp;&nbsp;New plants, walkways, driveways<br/>
                    &nbsp;&nbsp;<span style={{fontSize: "8px"}}>&#x25CF;</span>&nbsp;&nbsp;&nbsp;Patio decking, natural flagstone<br/>
                    &nbsp;&nbsp;<span style={{fontSize: "8px"}}>&#x25CF;</span>&nbsp;&nbsp;&nbsp;Faux stone, sand pits, built-in BBQ's<br/>
                    &nbsp;&nbsp;<span style={{fontSize: "8px"}}>&#x25CF;</span>&nbsp;&nbsp;&nbsp;Outdoor kitchens, patios<br/><br/>

                    <span style={{fontSize: "13px", color: "#8B0000", fontStyle: "italic"}}>Commercial Landscape Installation</span><br/>
                    &nbsp;&nbsp;<span style={{fontSize: "8px"}}>&#x25CF;</span>&nbsp;&nbsp;&nbsp;Apartment complex, town home, condominium<br/>
                    &nbsp;&nbsp;<span style={{fontSize: "8px"}}>&#x25CF;</span>&nbsp;&nbsp;&nbsp;Parks, recreation facilities, corporate<br/>
                    &nbsp;&nbsp;<span style={{fontSize: "8px"}}>&#x25CF;</span>&nbsp;&nbsp;&nbsp;Golf courses<br/>
                </p>
                <a href="/gallery-db/">
                    <p className="gallery-link">
                        Go to Gallery  >
                    </p>
                </a>
            </div>
          </div>
          <hr style={{margin: 0, marginTop: '20px', borderColor: 'rgb(150, 150, 150)'}}/>   

          <h2 className="services-title">POOL & SPA / GENERAL CONSTRUCTION <span style={{color: "#943616"}}>SERVICES</span></h2>

          <div className="profile-div">
            <div className="image-div">
                <img width={202} height={202} style={{boxShadow: "0px 5px 15px 0px #000000", marginBottom: "25px"}} alt="PoolProfilePic" src={poolprof}/>
            </div>
            
            <div>
                <div style={{display: "flex"}}>
                    <p className="title-column">
                        POOL & SPA
                    </p>
                    <p>
                        <span style={{fontSize: "13px", color: "#8B0000", fontStyle: "italic"}}>From Design through Completion</span><br/>
                        &nbsp;&nbsp;<span style={{fontSize: "8px"}}>&#x25CF;</span>&nbsp;&nbsp;&nbsp;New Pools<br/>
                        &nbsp;&nbsp;<span style={{fontSize: "8px"}}>&#x25CF;</span>&nbsp;&nbsp;&nbsp;Renovation<br/>
                        &nbsp;&nbsp;<span style={{fontSize: "8px"}}>&#x25CF;</span>&nbsp;&nbsp;&nbsp;Custom Built Pools<br/>
                        &nbsp;&nbsp;<span style={{fontSize: "8px"}}>&#x25CF;</span>&nbsp;&nbsp;&nbsp;Plaster / Tile<br/>
                        &nbsp;&nbsp;<span style={{fontSize: "8px"}}>&#x25CF;</span>&nbsp;&nbsp;&nbsp;Stonescape Pebbles<br/>
                        &nbsp;&nbsp;<span style={{fontSize: "8px"}}>&#x25CF;</span>&nbsp;&nbsp;&nbsp;Decking<br/>
                        &nbsp;&nbsp;<span style={{fontSize: "8px"}}>&#x25CF;</span>&nbsp;&nbsp;&nbsp;Landscaping<br/>
                    </p>
                </div>

                <div style={{display: "flex"}}>
                    <p className="title-column">
                        Land / Real Estate Development & Consultations
                    </p>
                    <p>
                        <span style={{fontSize: "13px", color: "#8B0000", fontStyle: "italic"}}>Park & Recreational Facilities</span><br/>
                        &nbsp;&nbsp;<span style={{fontSize: "8px"}}>&#x25CF;</span>&nbsp;&nbsp;&nbsp;Theme parks, Aquatic facilities, etc.<br/>
                        <span style={{fontSize: "13px", color: "#8B0000", fontStyle: "italic"}}>Tourism, Hospitality & Leisure Facilities</span><br/>
                        &nbsp;&nbsp;<span style={{fontSize: "8px"}}>&#x25CF;</span>&nbsp;&nbsp;&nbsp;Hotels, Resorts, etc.<br/>
                        &nbsp;&nbsp;<span style={{fontSize: "8px"}}>&#x25CF;</span>&nbsp;&nbsp;&nbsp;Golf courses, Ski slopes, Camp ground, etc.<br/>
                    </p>
                </div>
            </div>
          </div>
          <div className="profile-div" style={{marginBottom: "25px"}}>
            <div className="image-div">
                <img width={202} height={202} style={{boxShadow: "0px 5px 15px 0px #000000"}} alt="GeneralConstructProfilPic" src={gconprof}/>
            </div>
            
            <div>
                <div style={{display: "flex"}}>
                    <p className="title-column">
                        General Construction
                    </p>
                    <p>
                        <span style={{fontSize: "13px", color: "#8B0000", fontStyle: "italic"}}>Design Phase</span><br/>
                        &nbsp;&nbsp;<span style={{fontSize: "8px"}}>&#x25CF;</span>&nbsp;&nbsp;&nbsp;Site selection and scheduling<br/>
                        &nbsp;&nbsp;<span style={{fontSize: "8px"}}>&#x25CF;</span>&nbsp;&nbsp;&nbsp;Market analysis and concept design<br/>
                        &nbsp;&nbsp;<span style={{fontSize: "8px"}}>&#x25CF;</span>&nbsp;&nbsp;&nbsp;Layout plan and interior design<br/>
                        &nbsp;&nbsp;<span style={{fontSize: "8px"}}>&#x25CF;</span>&nbsp;&nbsp;&nbsp;Estimating and Value Engineering<br/>
                        &nbsp;&nbsp;<span style={{fontSize: "8px"}}>&#x25CF;</span>&nbsp;&nbsp;&nbsp;Permit drawings<br/>
                        &nbsp;&nbsp;<span style={{fontSize: "8px"}}>&#x25CF;</span>&nbsp;&nbsp;&nbsp;Construction documents<br/>
                        <span style={{fontSize: "13px", color: "#8B0000", fontStyle: "italic"}}>Construction Phase</span><br/>
                        &nbsp;&nbsp;<span style={{fontSize: "8px"}}>&#x25CF;</span>&nbsp;&nbsp;&nbsp;Green Build Construction (LEED-certified)<br/>
                        &nbsp;&nbsp;<span style={{fontSize: "8px"}}>&#x25CF;</span>&nbsp;&nbsp;&nbsp;Contracting<br/>
                        &nbsp;&nbsp;<span style={{fontSize: "8px"}}>&#x25CF;</span>&nbsp;&nbsp;&nbsp;Construction Management<br/>
                        &nbsp;&nbsp;<span style={{fontSize: "8px"}}>&#x25CF;</span>&nbsp;&nbsp;&nbsp;Post Construction Service<br/>
                    </p>
                </div>

                <a href="/gallery-pl/">
                    <p className="gallery-link">
                        Go to Gallery  >
                    </p>
                </a>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/services.tsx